import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, withPropsOnChange } from 'recompose';

import { labelsPropTypes } from './withRentalPlanLabels';

function flattenCampaignPlans(campaigns) {
    const rentalPlanIdSet = new Set();

    campaigns.forEach((campaign) => {
        campaign.rental_plans_ids.forEach((id) => rentalPlanIdSet.add(id));
    });

    return Array.from(rentalPlanIdSet);
}

const plusSignStyles = {
    lineHeight: 'inherit',
};

function mapRentalPlansToSelectorPoints(rentalPlans, labels, campaigns) {
    const productHasCampaigns = Array.isArray(campaigns) && campaigns.length > 0;
    const promotedRentalPlanIds = productHasCampaigns ? flattenCampaignPlans(campaigns) : [];
    const { planDurationLabel, planDurationPluralLabel } = labels;

    return rentalPlans.map((plan) => {
        const hasPromotion =
            productHasCampaigns && promotedRentalPlanIds.some((id) => plan.planId === id);

        return {
            planId: plan.planId,
            value: plan.minimumMonths,
            label:
                // eslint-disable-next-line no-nested-ternary
                plan.minimumMonths < 2 ? planDurationLabel : planDurationPluralLabel,
            hasAccentColors: hasPromotion,
        };
    });
}

export const pointPropTypes = {
    planId: PropTypes.number,
    value: PropTypes.node.isRequired,
    label: PropTypes.node.isRequired,
    hasAccentColors: PropTypes.bool,
};

export default function withRentalPlanSelectorPoints(EnhancedComponent) {
    @compose(
        withPropsOnChange(
            ['campaigns', 'rentalPlans', 'labels'],
            ({ campaigns, rentalPlans, labels }) => ({
                points: mapRentalPlansToSelectorPoints(rentalPlans, labels, campaigns),
            }),
        ),
    )
    class RentalPlanSelectorPointsHOC extends Component {
        render() {
            const { points, ...restProps } = this.props;
            return <EnhancedComponent points={points} {...restProps} />;
        }
    }
    RentalPlanSelectorPointsHOC.propTypes = {
        campaigns: PropTypes.arrayOf(
            PropTypes.shape({
                // TODO: create campaign prop types
            }),
        ),
        rentalPlans: PropTypes.arrayOf(
            PropTypes.shape({
                // TODO: create rental plan prop types
            }),
        ),
        labels: PropTypes.shape(labelsPropTypes).isRequired,
        points: PropTypes.arrayOf(PropTypes.shape(pointPropTypes)),
    };

    RentalPlanSelectorPointsHOC.defaultProps = {
        campaigns: [],
        rentalPlans: [],
        points: [],
    };

    return RentalPlanSelectorPointsHOC;
}
